import { Box, Flex, FlexProps, Text, defineStyle } from '@chakra-ui/react';

interface TagGroupProps extends FlexProps {
  tags: string[];
  variant?: 'dark' | 'light' | 'category';
}

export const TagGroup = ({ tags, ...flexProps }: TagGroupProps) => {
  return (
    <Flex mt={7} gap="2" wrap="wrap" {...flexProps}>
      {tags.map((tagName) => (
        <Box
          key={'filter_tag_button_' + tagName}
          style={TagStyle}
          backgroundColor="tag-bg"
          borderRadius="1px"
          px={2}
          py="2px"
        >
          <Text color="text.500" variant="text-md/lineHeight-6/font-normal" textTransform="capitalize">
            {tagName}
          </Text>
        </Box>
      ))}
    </Flex>
  );
};

const TagStyle = defineStyle({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: 'fit-content',
});
